import { z } from "zod";

import { defaultItem, defaultUrl, transformerMdContentParam, itemSchema, urlSchema } from "../shared";
import { createId } from "@paralleldrive/cuid2";

// Schema
export const publicationSchema = itemSchema.extend({
  name: z.string().min(1),
  publisher: z.string(),
  date: z.string(),
  summary: transformerMdContentParam,
  url: urlSchema,
});

export const minimalPublicationSchema = publicationSchema.omit({
  id: true,
  visible: true,
});

// Type
export type Publication = z.infer<typeof publicationSchema>;
export type MinimalPublication = z.infer<typeof minimalPublicationSchema>;

// Defaults
export const defaultPublication: Publication = {
  ...defaultItem,
  name: "",
  publisher: "",
  date: "",
  summary: "",
  url: defaultUrl,
};

export const deminimalizePublication = (publication: MinimalPublication): Publication => {
  return {
    ...defaultPublication,
    ...publication,
    id: createId(),
  };
};
